export const numberWithSpaces = (x: string | number): string => {
  if (/\d/.test(x as string)) {
    // eslint-disable-next-line security/detect-unsafe-regex -- no harm regex
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }
  return x.toString();
};
